document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".Panneld");

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        sections.forEach(sec => sec.classList.remove("is-active"));
        entry.target.classList.add("is-active");

      }

    });

  }, {
    threshold: 0.2
  });

  sections.forEach(sec => observer.observe(sec));

  (function() {
    const sliders = document.querySelectorAll('.product-card-swiper');
    if (!sliders.length) return;
    function loadSwiperCSS() {
      if (document.querySelector('link[href*="swiper-bundle.min.css"]')) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        link.onload = () => resolve();
        link.onerror = () => reject(new Error('Failed to load Swiper CSS'));
        document.head.appendChild(link);
      });
    }
    function loadSwiperJS() {
      if (window.Swiper) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Swiper JS'));
        document.body.appendChild(script);
      });
    }
    function initAllSliders() {
      document.querySelectorAll('.product-card-swiper').forEach(container => {
        if (container.swiper) return;
        container.swiper = new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: container.querySelector('.swiper-button-next17'),
            prevEl: container.querySelector('.swiper-button-prev17'),
          },
          loop: true,
          autoHeight: false,
          touchRatio: 0.5,
          preventClicks: true,
          preventClicksPropagation: true,
          observeParents: true,
          observeSlotChildren: true,
        });
      });
    }
    loadSwiperCSS()
      .then(() => loadSwiperJS())
      .then(() => {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllSliders);
        else initAllSliders();
      })
      .catch(err => console.warn('Swiper loading error:', err));
  })();


});


